'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');
var magicSdk = require('@gig/magic-sdk');
var tslib = require('tslib');

function securityQuestion() {
    var _this = this;
    return {
        id: 'security-question-wrapper',
        component: 'magic-ui-form-field',
        isDataField: false,
        validationBase: 'securityQuestion',
        children: [
            {
                id: 'securityQuestion',
                component: 'magic-ui-dropdown',
                isDataField: true,
                testId: 'step2-security-question',
                validation: [
                    {
                        name: 'required',
                        fn: magicFormBuilder.required,
                    },
                    {
                        name: 'min-length',
                        fn: magicFormBuilder.minLength(1),
                    },
                ],
                converter: function (formValue) {
                    return {
                        securityQuestionID: formValue.securityQuestion.value,
                    };
                },
                preloadProperties: function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                    var securityQuestionList;
                    return tslib.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, magicSdk.magic.invokeCached(60, magicSdk.magic.methods.users, 'listSecurityQuestions')()];
                            case 1:
                                securityQuestionList = (_a.sent());
                                return [2 /*return*/, {
                                        options: securityQuestionList.map(function (question) { return ({
                                            name: magicCommon.translate(question.question) ||
                                                magicCommon.translate("sign-up.step-2.security-questions." + question.id),
                                            value: question.id,
                                        }); }),
                                    }];
                        }
                    });
                }); },
            },
        ],
    };
}
function securityAnswer(options) {
    return {
        id: 'securityAnswer',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'security-answer',
        properties: {
            placeholder: magicCommon.translate('sign-up-step-two.security-answer.placeholder'),
        },
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
            },
            {
                name: 'min-length',
                fn: magicFormBuilder.maxLength(options.securityAnswerMaxLength),
            },
        ],
    };
}

exports.securityAnswer = securityAnswer;
exports.securityQuestion = securityQuestion;
